var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticStyle: { "margin-bottom": "16px", display: "flex" } },
        [
          _c(
            "b-button",
            {
              staticClass: "ml-1",
              staticStyle: {
                display: "flex",
                "flex-direction": "row",
                "align-items": "center"
              },
              on: { click: _vm.exportLots }
            },
            [
              _c("i", {
                staticClass: "p-0 fa fa-download",
                staticStyle: { "margin-right": "8px" }
              }),
              _vm._v(" Exportar a XLS\n    ")
            ]
          ),
          _vm._v(" "),
          _c(
            "b-button",
            {
              staticClass: "ml-1",
              staticStyle: {
                display: "flex",
                "flex-direction": "column",
                "align-items": "center"
              },
              on: { click: _vm.confirmCloseAllLots }
            },
            [
              _c("i", { staticStyle: { "margin-right": "8px" } }),
              _vm._v(" Cerrar todos\n    ")
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticStyle: { "margin-bottom": "16px", display: "flex" } }),
      _vm._v(" "),
      !_vm.loading
        ? _c("v-server-table", {
            ref: "closed-lots-table",
            staticClass: "table-hide-nativetoggler",
            attrs: {
              url: "lista-lotes/",
              columns: _vm.columns,
              options: _vm.options
            },
            scopedSlots: _vm._u([
              {
                key: "create_date",
                fn: function(props) {
                  return _c("div", {}, [
                    _c("span", [
                      _vm._v(
                        " " +
                          _vm._s(_vm._f("formatDate")(props.row.create_date))
                      )
                    ])
                  ])
                }
              },
              {
                key: "fecha_inicio_prevista",
                fn: function(props) {
                  return _c("div", {}, [
                    _c("span", [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm._f("formatDate")(
                              props.row.fecha_inicio_prevista
                            )
                          )
                      )
                    ])
                  ])
                }
              },
              {
                key: "fecha_cierre_prevista",
                fn: function(props) {
                  return _c("div", {}, [
                    _c("span", [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm._f("formatDate")(
                              props.row.fecha_cierre_prevista
                            )
                          )
                      )
                    ])
                  ])
                }
              },
              {
                key: "fecha_inicio_real",
                fn: function(props) {
                  return _c("div", {}, [
                    _c("span", [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm._f("formatDate")(props.row.fecha_inicio_real)
                          )
                      )
                    ])
                  ])
                }
              },
              {
                key: "actions",
                fn: function(props) {
                  return _c(
                    "div",
                    {},
                    [
                      _c("ActionsCierreLotes", {
                        attrs: { data: props.row, index: props.index }
                      })
                    ],
                    1
                  )
                }
              },
              {
                key: "child_row",
                fn: function(props) {
                  return _vm.options.details ? undefined : undefined
                }
              }
            ])
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-modal",
        { ref: "modalPreventCerrarTodosLote", on: { ok: _vm.closeLots } },
        [_vm._v("\n    ¿Desea cerrar todos los lotes?\n  ")]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        { ref: "modalPreventCerrarLote", on: { ok: _vm.closeLot } },
        [
          _vm._v(
            "\n    ¿Desea cerrar el lote " +
              _vm._s(_vm.selectedLot.id) +
              ", con la descripción '" +
              _vm._s(_vm.selectedLot.descripcion) +
              "'?\n  "
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/Layout/SystemManagement/cierre-lotes-management/cierre-lotes-list/CierreLotesList.vue?vue&type=template&id=1ad4784c&
// module id = null
// module chunks = 